import { bus } from "@App/domain/bus";
import { EventType } from "@App/domain/events";
import type { ID } from "@App/types";
import { useEffect } from "react";

type UseNoSlotsAlertTrackingParams = {
  // whether the "no slots" alert is currently shown
  active: boolean;
  organizationId: number;
  garageId: ID;
  serviceId: ID;
};

/**
 * Publishes BOOKING_NO_SLOTS_SHOWN when the "no slots" alert becomes visible.
 * The caller decides when the alert is shown via the `active` flag.
 */
export const useNoSlotsAlertTracking = ({
  active,
  organizationId,
  garageId,
  serviceId,
}: UseNoSlotsAlertTrackingParams) => {
  useEffect(() => {
    if (!active) return;

    bus.publish({
      type: EventType.BOOKING_NO_SLOTS_SHOWN,
      organization_id: organizationId,
      garage_id: garageId,
      service_id: serviceId,
    });
  }, [active, organizationId, garageId, serviceId]);
};
